// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    BROKER_GET_MY_INVESTMENTS_SUCCESS,
    SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE,
} = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    steps: [
        {
            valid: false,
            errorFlags: false,
        },
    ],
    investmentsFetched: false,
    submitSuccessful: false,
    isLoading: false,
});

const RAReimbursementRequest = (state = initialState, action) => {
    switch (action.type) {
        case BROKER_GET_MY_INVESTMENTS_SUCCESS:
            return state.merge({
                investmentsFetched: true,
            });
        case actionTypes.RA_REIMBURSEMENT_REQUEST_IN_PROGRESS:
            return state.merge({
                isLoading: true,
            });
        case actionTypes.RA_REIMBURSEMENT_REQUEST_SUCCESS:
            return state.merge({
                submitSuccessful: true,
                isLoading: false,
            });
        case SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_REIMBURSEMENT_REQUEST_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_REIMBURSEMENT_REQUEST_RESET:
            return initialState;
        case actionTypes.RA_REIMBURSEMENT_REQUEST_SET_REIMBURSEMENT_AMOUNT:
            return state.mergeIn(['reimbursementDetails'], {
                amount: action.payload,
                isDirty: true,
            });
        default:
            return state;
    }
};

module.exports = RAReimbursementRequest;
